import { useQuery } from '@tanstack/react-query';
import { getSimulationById } from 'Services';
import { RQ_SINGLE_SIMULATION } from 'Utils';

const useGetSimulationById = (simulationId: number | null) => {
    return useQuery([RQ_SINGLE_SIMULATION, simulationId], () => getSimulationById(simulationId!));
};

export default useGetSimulationById;
